import { ServiceCode } from '@shared/ui-service';

export const SERVICE_CODE_TO_NAME_MAP: { [key: string]: string } = {
  [ServiceCode.TrashPickUpTownServiceDetailDto]: 'Trash',
  [ServiceCode.RecyclingTownServiceDetailDto]: 'Recycling',
  [ServiceCode.TrashPickUpAndRecyclingTownServiceDetailDto]: 'Trash & Recycling',
  [ServiceCode.FoodWasteTownServiceDetailDto]: 'Food Waste',
  [ServiceCode.BulkPickupTownServiceDetailDto]: 'Bulk Waste',
  [ServiceCode.CommercialTrash]: 'Trash',
  [ServiceCode.CommercialRecycling]: 'Recycling',
  [ServiceCode.CommercialTrashAndRecycling]: 'Trash & Recycling',
  [ServiceCode.CommercialFoodWaste]: 'Food Waste',
  [ServiceCode.CommercialBulk]: 'Bulk Waste',
  [ServiceCode.RollOff]: 'dumpster rental services',
};
